(() => {
  const getModal = (id) => document.getElementById(id);
  let lastActive = null;

  const openModal = (modal) => {
    if (!modal) return;
    lastActive = document.activeElement;

    const panel = modal.querySelector(".hoa-modal__panel");
    modal.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("hoa-modal-open");
    setTimeout(() => panel && panel.focus(), 0);
  };

  const closeModal = (modal) => {
    if (!modal) return;
    modal.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("hoa-modal-open");
    if (lastActive && typeof lastActive.focus === "function") lastActive.focus();
    lastActive = null;
  };

  document.addEventListener("click", (e) => {
    // OPEN (delegated) - работи и след смяна на вариант
    const opener = e.target.closest("[data-hoa-modal-open]");
    if (opener) {
      const id = opener.getAttribute("data-hoa-modal-open");
      openModal(getModal(id));
      return;
    }

    // CLOSE (overlay или X)
    const closer = e.target.closest("[data-hoa-modal-close]");
    if (closer) {
      const modal = e.target.closest(".hoa-modal");
      closeModal(modal);
      return;
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    const modal = document.querySelector(".hoa-modal[aria-hidden='false']");
    if (modal) closeModal(modal);
  });
})();
